import { request as baseLibrReq } from '@tencent/ppd-base-libs';

let request = baseLibrReq;

export const getRequest = () => request;

export function setRequest(requestAdapter: any) {
  request = requestAdapter;
  console.log(request, 'setRequest');
}
